import { useEffect, useRef, useState } from "react"
import { useSnapshot } from "valtio"
import Utils from "../util/Utils"
import { taskStore } from "./task-store"
import { myactionsstore } from "../my-actions/store-myactions"
import Api from "../state/Api"
import Newapi from "../state/new-api"
import { ACTUALSLIST, arrayListsinDsr } from "../util/constants"
import { configStore } from "../state/CommonState"
import { Switch } from "@mui/material"

export function OneInput(props) {

    const { label, name, isDisabled, ...otherProps } = props
    useSnapshot(taskStore)
    let task = taskStore.current
    if (props.record) task = props.record
    return (
        <>
            <td>
                <div style={{ marginRight: '5px', marginTop: '3px' }}>{label}</div>
            </td>
            <td {...otherProps}>
                <input {...otherProps} className={`input is-small ${(!taskStore.current?.isValid && Array.isArray(taskStore.current?.isValidfield) && taskStore.current.isValidfield.includes(name)) ? "is-danger" : ""} `} defaultValue={task[name]}
                    onChange={(e) => {
                        task[name] = e.target.value
                        console.log('changed value =', task[name])
                    }}
                    disabled={isDisabled}
                    onKeyDown={(e) => {
                        if (label == "Contact Number" && props.message) {
                            ["e", "E", "+"].includes(e.key) && e.preventDefault()
                        }
                    }
                    }
                    onInput={(e) => {
                        if (label == "Contact Number" && props.message) {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                        }
                    }}
                />




            </td>
        </>
    )
}

export function ShipConInput(props) {
    const { label, name, val, ...otherProps } = props;
    const [value, setValue] = useState(val); 
    useSnapshot(taskStore);

    let task = taskStore.current;
    if (props.record) task = props.record;
    useEffect(() => {
        setValue(val);
        task[name] = val
    }, [val]); 

    return (
        <>
            <td>
                <div style={{ marginRight: '5px', marginTop: '3px' }}>{label}</div>
            </td>
            <td {...otherProps}>
                <input
                    {...otherProps}
                    className={`input is-small ${(!taskStore.current?.isValid &&
 Array.isArray(taskStore.current?.isValidfield) &&
 taskStore.current.isValidfield.includes(name))
 ? "is-danger" : ""}`}
                    value={value} 
                    onChange={(e) => {
                        setValue(e.target.value); 
                        task[name] = e.target.value;
                        console.log('changed value =', task[name]);
                    }}
                    onKeyDown={(e) => {
                        if (label === "Contact Number" && props.message) {
                            ["e", "E", "+"].includes(e.key) && e.preventDefault();
                        }
                    }}
                    onInput={(e) => {
                        if (label === "Contact Number" && props.message) {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                        }
                    }}
                />
            </td>
        </>
    );
}




export function OneInput5(props) {
    const { label, name, record, disabled, ...otherProps } = props
    const [cursor, setCursor] = useState(0)
    const ref = useRef(null)
    useSnapshot(myactionsstore)
    useEffect(() => {
        const input = ref.current
        if (input) {
            input.setSelectionRange(cursor, cursor)
        }
    }, [ref, cursor])
    if (record && record[name] == undefined) {
        record[name] = ""
    }

    const handleChange = (e) => {
        setCursor(e.target.selectionStart)
        record[name] = e.target.value
    }
    
    return (
        <>
            <div className="columns">
                <div className="column is-6 py-2">
                    <div style={{ marginRight: '5px', marginTop: '3px', fontWeight: "bold" }}>{label}</div>
                </div>
                <div className="column is-6 py-2">
                    {(record) ? <input {...otherProps} style={{ width: "100%" }} ref={ref}
                        disabled={disabled}
                        value={record[name]} className={myactionsstore.error.indexOf(name) == -1 ? "input is-small" : "input is-small is-danger"}
                        onChange={(e) => {
                            handleChange(e)
                            console.log('changed value =', record[name], record)
                        }}
                    /> : <></>
                    }
                </div>
            </div>
        </>
    )
}

export function OneToggle(props) {
    const { label, name, record, disabled, ...otherProps } = props
    return (
        <>
            <div className="columns">
                <div className="column is-6 py-2">
                    <label style={{marginRight: '5px', marginTop: '3px', fontWeight: "bold"}}>{label}</label>
                </div>
                <div className="column is-6 py-2">
                    <Switch checked={record[name]} disabled={disabled} onChange={(e)=>{
                        record[name] = e.target.checked
                    }} color="primary"/>
                </div>
            </div>
        </>
    )
}


export function OneInput8(props) {
    const { label, name, record, disabled, ...otherProps } = props
    const [cursor, setCursor] = useState(0)
    const ref = useRef(null)
    useSnapshot(myactionsstore)
    useEffect(() => {
        const input = ref.current
        if (input) {
            input.setSelectionRange(cursor, cursor)
        }
    }, [ref, cursor])
    if (record && record[name] == undefined) {
        record[name] = ""
    }

    const handleChange = (e) => {
        setCursor(e.target.selectionStart)
        record[name] = e.target.value
    }
    
    return (
        <>
            <div className="columns">
                <div className="column">
                    {(record) ? <input {...otherProps} style={{ width: "100%" }} ref={ref}
                        disabled={disabled}
                        value={record[name]} className={myactionsstore.error.indexOf(name) == -1 ? "input is-small" : "input is-small is-danger"}
                        onChange={(e) => {
                            handleChange(e)
                            console.log('changed value =', record[name], record)
                        }}
                    /> : <></>
                    }
                </div>
            </div>
        </>
    )
}

export function OneInput5table(props) {
    const { search, key1, label, name, ind, index, record, isValid = true, errorMsg, onChange, disable = true, ...otherProps } = props;
    const [cursor, setCursor] = useState(0)
    const [list, setList] = useState([])
    const ref = useRef(null)
    // useEffect(() => {
    //     if(name!="total_package" || name !== "driver_number"){
    //         const input = ref.current
    //         if (input) {
    //             input.setSelectionRange(cursor, cursor)
    //         }
    //     }
    // }, [ref, cursor])
    if (record && record[name] == undefined) {  
        record[name] = ""
    }
    let id = name
    if(key1!=undefined){
        id=name+key1
    }
    useSnapshot(myactionsstore)
    const handleChange = async (e, index) => {
        e.preventDefault()
        // console.log("record[name] = e.target.value", e.target.value, name)
        
        if(name != "number_of_package" && name!="total_package" && name !== "driver_number" ){
            console.log("record[name] = e.target.value----------")
            setCursor(e.target.selectionStart)
        }
        if(name === "total_package" || name === "driver_number" || name === "number_of_package"){
            if(e.target.value.match(/\d/g)){
                let l = e.target.value.match(/\d/g).join('')
                setCursor(l.length)
                record[name] = l
            }else{
                setCursor(0)
                record[name] = ""
            }
        }else{
            if(search && name !== 'transport_name'){
                let results
                if(e.target.value && e.target.value.length > 0){
                    record[name] = e.target.value
                    let url = `${process.env.REACT_APP_API_SERVER}/api/v1/location/fetchaddress2/${encodeURIComponent(e.target.value)}`
                    results = await Newapi.get(url)
                }else{
                    record[name] = ""
                    results = []
                }
                setList(results)
            }else if(name === 'transport_name'){
                record[name] = e.target.value
                setList(["Amazon Freight", "Forward Air", "Estes Express", "ArcBest", "Southeastern Freight Lines", "XPO", "TForce Freight"])
            }else{
                record[name] = e.target.value
            }
            
        }
    }
    let a = ""
    switch (name) {
        case "container_number":
            a = 'container_number' + ind
            break;
        case "container_number_vehicle":
            a = 'container_number_vehicle' + ind
            break;
        default:
            a = name
            break;
    }
    let type = "text"   
    if(name === "total_package" || name === "driver_number" || name === "number_of_package" || name === "transport_ref_number"){
        type  = "number"
    }
    return (
        <>

            { (search  || name === "transport_name") ? 
                <>
                <input
                  autoComplete="off"
                  {...props}
                  name={id}
                  value={record[name]}
                  list={id}
                  maxLength={name === 'vehicle' ? 20 : undefined}
                  onChange={(e) => {
                    if (!e.nativeEvent.inputType) {
                      e.target.blur();
                    }
                    if(search || name === 'transport_name'){
                        handleChange(e, index)
                    }
                    if(name !== "container_number"){
                        if(name === "container_number_vehicle"){
                            return onChange(name, e.target.value.toUpperCase())
                        }
                        onChange(name, e.target.value)
                    }
                  }}
                  style={{border: `${!(myactionsstore.error.indexOf(a) == -1) || !isValid ? '1px solid red' : '1px solid grey'}`}}
                  className={`border-solid border w-full rounded-md p-1.5`}
                />
                {list && list.length > 0 ? (
                  <datalist id={id}>
                    {list.map((e, i) => (
                      <option key={i} value={e} />
                    ))}
                  </datalist>
                ) : null}
                {!isValid ? <p style={{color: 'red'}} class = 'text-sm text-red-500'>{errorMsg}</p> : <></>}
              </>
            :   <div>
                    <input key={name+index}
                        style={{border: `${ !(myactionsstore.error.indexOf(a) == -1) || !isValid ? '1px solid red' : '1px solid grey' }`}} 
                        className={`border-solid border w-full rounded-md p-1.5`}
                        type={type} {...otherProps}
                        value={record[name]}
                        maxLength={name === 'vehicle' ? 20 : undefined}
                        disabled={!disable}
                        onChange={(e) => {
                            if(name !== "container_number"){
                                if(name === "container_number_vehicle"){
                                    return onChange(name, e.target.value.toUpperCase())
                                }
                                onChange(name, e.target.value)
                            }else{
                                console.log("name-----------> handleChange" )
                                handleChange(e, index)
                            }
                        }}
                    />
                    {!isValid ? <p style={{color: 'red'}} class = 'text-sm text-red-500'>{errorMsg}</p> : <></>}
                </div>
            }

        </>
    )
}
export default function OneSelect6({
  label,
  dataList = [],
  isDisabled,
  value = "",
  onChange,
}) {
  return (
  <div className="field is-horizontal">
  {label && (
    <div className="field-label is-small">
      <label className="label is-small">{label}</label>
    </div>
  )}
  <div className="field-body">
    <div className="field">
      <div className="control">
        <div className="select is-fullwidth is-small">
          <select
          disabled={isDisabled}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
          >
            <option value="">Select</option>
            {dataList.map((item) => (
              <option
                key={item}
                value={item}
              >
                {item}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  </div>
</div>

  );
}

export function OneSelect4(props) {
    const { label, name, record, isDisabled, ...otherProps } = props
    if (record && record[name] == undefined) {
        record[name] = "N"
    }

    if (record[name] == "" || record[name].toLowerCase() == 'no') {
        record[name] = "N"
    }

    if (['yes', 'y', 'n'].indexOf(record[name].toLowerCase()) == -1) {
        record[name] = "N"
    }
    return (
        <>
            <div className="columns">
                <div className="column is-6 py-2">
                    <div style={{ marginRight: '5px', marginTop: '3px', fontWeight: "bold" }}>{label}</div>
                </div>
                <div className="column is-6 py-2">
                    {(record) ?
                        <div class="control">
                            <label class="radio">
                                <input type="radio" disabled={isDisabled} name="answer" onChange={(e) => {
                                    record[name] = "Y"
                                    console.log('changed value =', record[name])
                                }} checked={record[name] == 'Y'} />
                                Yes
                            </label>
                            <label class="radio">
                                <input type="radio" disabled={isDisabled} name="answer" onChange={(e) => {
                                    record[name] = "N"
                                    console.log('changed value =', record[name])
                                }} checked={record[name] == 'N'} />
                                No
                            </label>
                        </div>

                        : <></>
                    }
                </div>
            </div>
        </>
    )
}

export function OneDateAndTime(props) {
    const { label, name, record, isDisabled, callback,...otherProps } = props;
    const [lastValidDate, setLastValidDate] = useState(record[name] || "");

    // Initialize the field in record if not defined
    if (record && record[name] === undefined) {
        record[name] = "";
    }

    // Handle date reformatting for 10-character dates (if needed)
    if (record && record[name].length === 10) {
        let dateParts = record[name].split("-");
        if (dateParts.length === 3 && dateParts[0].length <= 2) {
            record[name] = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
        }
    }

    return (
        <div className="columns">
            {/* Label Column */}
            <div className="column is-6 py-2">
                <div style={{ marginRight: "5px", marginTop: "3px", fontWeight: "bold" }}>
                    {label}
                </div>
            </div>

            <div className="column is-6 py-2">
                {record ? (
                    <input
                        {...otherProps}
                        type="datetime-local" 
                        style={{
                            width: "100%",
                            border: "2px solid #ccc",
                            borderRadius: "4px",
                        }}
                        value={record[name]}
                        disabled={isDisabled}
                        onChange={(e) => {
                            if(callback){
                                callback(e)
                            }else{
                                record[name] = e.target.value;                             
                                setLastValidDate(e.target.value);
                            } 
                        }}
                    />
                ) : null}
            </div>
        </div>
    );
}

export function OneDateTime(props){
        const { label, name, record, isDisabled, callback,...otherProps } = props;

    return(<div className="columns">
        <div className="column is-6 py-2">
                <div style={{ marginRight: "5px", marginTop: "3px", fontWeight: "bold" }}>
                    {label}
                </div>
            </div>
  <div className="column is-6 py-2" style={{ display: 'flex', gap: '4px' }}>
        <input
        disabled={isDisabled}
          type="date"
          style={{
                    width: "100%",
                    border: "2px solid #ccc",
                    borderRadius: "4px",
                }}
          className="input is-small"
          value={record[name]?.split('T')[0] || ''}
          onChange={(e) => {
            const date = e.target.value;
            record[name] = `${date}`;
          }}
        />
        <input
          disabled={isDisabled}
          type="time"
          className="input is-small"
          style={{
                   width: "100%",
                   border: "2px solid #ccc",
                   borderRadius: "4px",
                }}
          value={record[name]?.split('T')[1] || ''}
          onChange={(e) => {
            const time = e.target.value;
            const existingDate = record[name]?.split('T')[0] ;
            if(existingDate) record[name] = `${existingDate}T${time}`;
          }}
        />
  </div>
  </div>
     )
}

export function OneDateTime1(props){
  const { label, name, record, isDisabled, callback, ...otherProps } = props;
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      if (typeof window === "undefined" || typeof navigator === "undefined") return;
      const ua = navigator.userAgent || navigator.vendor || window.opera || "";
      const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
      const isTouchDevice = ('ontouchstart' in window || navigator.maxTouchPoints > 0);
      const isSmallScreen = window.innerWidth <= 600;
      setIsMobile(Boolean(isMobileUA || (isSmallScreen && isTouchDevice)));
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <div className="flex flex-col w-full">
      <div className="w-full py-1">
        <div style={{
          fontSize: "12px",
          color: process.env.REACT_APP_ENTERPRISE_COLOUR || "#2C358A",
          fontWeight: "bold"
        }}>
          {label}
        </div>
      </div>
      <div className="w-full flex flex-row gap-2 py-1">
        <div style={{ position: "relative", width: "100%" }}>
          <input
            disabled={isDisabled}
            type="date"
            placeholder="Select Date"
            style={{
              width: "100%",
              border: "1px solid #D4D4D4",
              borderRadius: "6px",
              padding: isMobile ? "6px 28px 6px 8px" : "6px 8px",
              appearance: isMobile ? "none" : "auto",
              WebkitAppearance: isMobile ? "none" : "auto",
              MozAppearance: isMobile ? "none" : "auto"
            }}
            className="input is-small text-xs"
            value={record && record[name]?.split('T')[0] || ''}
            onChange={(e) => {
              const date = e.target.value;
              const existingTime = (record && record[name]?.split('T')[1]) || '';
              const val = date ? (existingTime ? `${date}T${existingTime}` : `${date}`) : '';
              if (record) record[name] = val;
              if (callback) callback(val);
            }}
            {...otherProps}
          />
          {isMobile && (
            <span
              style={{
                position: "absolute",
                right: "8px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: isDisabled ? "#999999" : "#666666",
                opacity: isDisabled ? 0.6 : 1
              }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
            </span>
          )}
        </div>
        <div style={{ position: "relative", width: "100%" }}>
          <input
            disabled={isDisabled}
            type="time"
            style={{
              width: "100%",
              border: "1px solid #D4D4D4",
              borderRadius: "6px",
              padding: isMobile ? "6px 28px 6px 8px" : "6px 8px",
              appearance: isMobile ? "none" : "auto",
              WebkitAppearance: isMobile ? "none" : "auto",
              MozAppearance: isMobile ? "none" : "auto"
            }}
            className="input is-small text-xs"
            value={record && record[name]?.split('T')[1] || ''}
            onChange={(e) => {
              const time = e.target.value;
              const existingDate = (record && record[name]?.split('T')[0]) || '';
              const val = time ? (existingDate ? `${existingDate}T${time}` : `T${time}`) : '';
              if (record) record[name] = val;
              if (callback) callback(val);
            }}
            {...otherProps}
          />
          {isMobile && (
            <span
              style={{
                position: "absolute",
                right: "8px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: isDisabled ? "#999999" : "#666666",
                opacity: isDisabled ? 0.6 : 1
              }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
export function OneDate(props) {
    const { label, name, record, isDisabled, ...otherProps } = props;
    const [lastValidDate, setLastValidDate] = useState(record[name] || "");

    if (record && record[name] === undefined) {
        record[name] = "";
    }

    let value = "";
    if (record && record[name] && record[name].length === 10) {
        let l = record[name].split("-");
        if (l.length === 3 && l[0].length === 4) {
            value = `${l[2]}-${l[1]}-${l[0]}`;
        } else {
            value = record[name]; 
        }
    }
    const keysArray = Object.keys(ACTUALSLIST); 
    const index = keysArray.indexOf(name);
    let minDate = "";
    const today = new Date().toISOString().split("T")[0];
    
    if (index > 0) {
        for (let i = index - 1; i >= 0; i--) {
            const prevKey = keysArray[i];
    
            let earliestDate = null;
    
            for (const key of arrayListsinDsr) {
                const list = record[key];
                if (Array.isArray(list)) {
                    for (const item of list) {
                        const dateStr = item?.[prevKey];
                        if (dateStr) {
                            const [dd, mm, yyyy] = dateStr.split("-");
                            const dateObj = new Date(`${yyyy}-${mm}-${dd}`);
                            if (!earliestDate || dateObj < new Date(`${earliestDate.split("-")[2]}-${earliestDate.split("-")[1]}-${earliestDate.split("-")[0]}`)) {
                                earliestDate = dateStr;
                            }
                        }
                    }
                }
            }
    
            if (earliestDate) {
                minDate = earliestDate;
                break;
            }
            if (record[prevKey]) {
                minDate = record[prevKey];
                break;
            }
        }
    }
    

    return (
        <>
            <div className="columns">
                <div className="column is-6 py-2">
                    <div style={{ marginRight: "5px", marginTop: "3px", fontWeight: "bold" }}>{label}</div>
                </div>
                <div className="column is-6 py-2">
                    {record ? (
                        <input
                            {...otherProps}
                            type="date"
                            style={{ width: "100%" }}
                            value={value.split("-").reverse().join("-")} 
                            disabled={isDisabled}
                            min={
                                minDate
                                  ? (() => {
                                      const parts = minDate.split("-");
                                      if (parts.length !== 3) return undefined;
                              
                                      const isDDMMYYYY = parts[0].length === 2;
                                      return isDDMMYYYY
                                        ? `${parts[2]}-${parts[1]}-${parts[0]}` 
                                        : minDate;  
                                    })()
                                  : undefined
                              }
                                                          
                              
                            max={keysArray.includes(name) ? today : undefined}
                            onChange={(e) => {
                                let val = e.target.value;
                                if (val) {
                                    let parts = val.split("-"); 
                                    if (parts.length === 3) {
                                        record[name] = `${parts[2]}-${parts[1]}-${parts[0]}`; 
                                    }
                                }else{
                                    record[name] = val
                                }
                                setLastValidDate(record[name]);
                            }}
                        />
                    ) : null}
                </div>
            </div>
        </>
    );
}


export function OneDatetable(props) {
    const { label, name, record, disabled, containerRecord, ...otherProps } = props
    const [lastValidDate, setLastValidDate] = useState(record[name] || "");
    const [ret, setRet] = useState(configStore.modalvisibledata)
 useEffect(() => {
        setRet(configStore.modalvisibledata)
    },[])
    if (record && record[name] == undefined) {
        record[name] = ""
    }
    let value = "";
    if (record && record[name].length === 10) {
        let l = record[name].split("-");
        if (l.length === 3 && l[0].length === 4) {
            value = `${l[2]}-${l[1]}-${l[0]}`;
        } else {
            value = record[name]; 
        }
    }
    const keysArray = Object.keys(ACTUALSLIST); 
    const index = keysArray.indexOf(name);
    let minDate = "";
    const today = new Date().toISOString().split("T")[0];
   
    if (index > 0) {
        for (let i = index - 1; i >= 0; i--) {
            const prevKey = keysArray[i];
    
            if (containerRecord?.[prevKey]) {
                minDate = containerRecord[prevKey];
                break;
            }
    
            for (const listKey of arrayListsinDsr) {
                const list = ret?.[listKey];
                if (Array.isArray(list)) {
                    const found = list.find(item => item?.[prevKey]);
                    if (found) {
                        minDate = found[prevKey];
                        break;
                    }
                }
            }

            if (ret?.[prevKey]) {
                minDate = ret[prevKey];
                break;
            }
    
            if (minDate) break;
    
        }
    
    }
    
    

    return (
        <>

            {(record) ? <input {...otherProps} type={"date"} style={{ width: "100%" }} class="border-solid border w-full rounded-md p-1.5"
                 value={value.split("-").reverse().join("-")} 
                {...otherProps}
                disabled={disabled}
                min={
                    minDate
                      ? (() => {
                          const parts = minDate.split("-");
                          if (parts.length !== 3) return undefined;
                  
                          const isDDMMYYYY = parts[0].length === 2;
                          return isDDMMYYYY
                            ? `${parts[2]}-${parts[1]}-${parts[0]}` 
                            : minDate;  
                        })()
                      : undefined
                  }
                max={keysArray.includes(name) ? today : undefined}
                onChange={(e) => {
                    let val = e.target.value;
                    if (val) {
                        let parts = val.split("-"); 
                        if (parts.length === 3) {
                            record[name] = `${parts[2]}-${parts[1]}-${parts[0]}`; 
                        }
                    }else{
                        record[name] = val
                    }
                    setLastValidDate(record[name]);
                }}
            /> : <></>
            }

        </>

    )
}

export function OneInput2(props) {
    const { label, name1, name2, ...otherProps } = props
    useSnapshot(taskStore)
    let task = taskStore.current
    if (props.record) task = props.record
    let placeholder1 = ''
    if (name1 === 'setValueMin') placeholder1 = 'Minimum'
    let placeholder2 = ''
    if (name2 === 'setValueMax') placeholder2 = 'Maximum'
    return (
        <>
            <td>
                <div style={{ marginRight: '5px', marginTop: '3px' }}>{label}</div>
            </td>
            <td {...otherProps}>
                <tr>
                    <td>
                        <input placeholder={placeholder1} {...otherProps} className="input is-small" value={task[name1]}
                            onChange={(e) => {
                                task[name1] = e.target.value
                                console.log('changed value =', task[name1])
                            }} />
                    </td>
                    <td>
                        <input placeholder={placeholder2} {...otherProps} className="input is-small" value={task[name2]}
                            onChange={(e) => {
                                task[name2] = e.target.value
                                console.log('changed value =', task[name2])
                            }} />
                    </td>
                </tr>
            </td>
        </>
    )
}
export function OneSelect(props) {
    const { label, name, dataList, ...otherProps } = props
    useSnapshot(taskStore)
    let task = taskStore.current
    if (props.record) task = props.record
    return (
        <>
            <td>
                <div style={{ marginRight: '5px', marginTop: '3px' }}>{label}</div>
            </td>
            <td {...otherProps}>
                <select style={{ width: "100%" }} {...otherProps} className={`select is-small ${(!taskStore.current?.isValid &&
 Array.isArray(taskStore.current?.isValidfield) &&
 taskStore.current.isValidfield.includes(name))
 ? "is-danger" : ""} `} value={task[name]}
                    onChange={(e) => {
                        task[name] = e.target.value
                        console.log('changed value =', task[name])
                    }} >
                    {
                        dataList.map(e => <option value={e}>{e}</option>)
                    }
                </select>
            </td>
        </>
    )
}
export function OneSelect5(props) {
    const { label, name, dataList, ...otherProps } = props
    useSnapshot(taskStore)
    let task = taskStore.current
    if (props.record) task = props.record
    return (
        <>
            <td>
                <div style={{ marginRight: '5px', marginTop: '3px' }}>{label}</div>
            </td>
            <td {...otherProps} >
                <div className={`select is-small ${(!taskStore.current?.isValid &&
 Array.isArray(taskStore.current?.isValidfield) &&
 taskStore.current.isValidfield.includes(name))
 ? "is-danger" : ""} `}>
                    <select style={{ width: "100%" }} {...otherProps} value={task[name]}
                        onChange={(e) => {
                            task[name] = e.target.value
                            console.log('changed value =', task[name])
                        }} >
                        {
                            dataList.map(e => <option value={e}>{e}</option>)
                        }
                    </select>
                </div>

            </td>
        </>
    )
}

export function ShipConSelect(props) {
    const { label, name, val, dataList, ...otherProps } = props;
    const [selectedValue, setSelectedValue] = useState(val); 
    useSnapshot(taskStore); // Assuming taskStore is imported or declared globally
    useEffect(() => {
        setSelectedValue(val);
        task[name] = val
    }, [val]); 

    let task = taskStore.current;
    if (props.record) task = props.record;

    return (
        <>
            <td>
                <div style={{ marginRight: '5px', marginTop: '3px' }}>{label}</div>
            </td>
            <td {...otherProps}>
                <div className={`select is-small ${(!taskStore.current?.isValid &&
 Array.isArray(taskStore.current?.isValidfield) &&
 taskStore.current.isValidfield.includes(name))
 ? "is-danger" : ""}`}>
                    <select
                        style={{ width: "100%" }}
                        {...otherProps}
                        value={selectedValue} // Use selectedValue state for select value
                        onChange={(e) => {
                            setSelectedValue(e.target.value); // Update selectedValue state when select value changes
                            task[name] = e.target.value;
                            console.log('changed value =', task[name]);
                        }}
                    >
                        {dataList.map((e, index) => (
                            <option key={index} value={e}>{e}</option>
                        ))}
                    </select>
                </div>
            </td>
        </>
    );
}


export function OneSelect2(props) {
    const { label, name1, name2, dataList, ...otherProps } = props
    useSnapshot(taskStore)
    let task = taskStore.current
    if (props.record) task = props.record
    return (
        <>
            <td>
                <div style={{ marginRight: '5px', marginTop: '3px' }}>{label}</div>
            </td>
            <td {...otherProps}>
                <span>
                    <select {...otherProps} className="select is-small" value={task[name1]}
                        onChange={(e) => {
                            task[name1] = e.target.value
                            console.log('changed value =', task[name1])
                        }} >
                        {
                            dataList.map(e => <option value={e}>{e}</option>)
                        }
                    </select>
                    <select {...otherProps} className="select is-small" value={task[name2]}
                        onChange={(e) => {
                            task[name2] = e.target.value
                            console.log('changed value =', task[name2])
                        }} >
                        {
                            dataList.map(e => <option value={e}>{e}</option>)
                        }
                    </select>
                </span>
            </td>
        </>
    )
}
export function OneLabel(props) {
    const { label, name, ...otherProps } = props
    useSnapshot(taskStore)
    let task = taskStore.current
    if (props.record) task = props.record
    return (
        <>
            <td>
                <div style={{ marginRight: '5px', marginTop: '3px' }}>{label}</div>
            </td>
            <td {...otherProps}>
                {
                    (name === 'dueDate') ?
                        <div>{Utils.formatToDateTime1(task.dueDate, task.dueTime)}</div>
                        : <div>{task[name]}</div>
                }
            </td>
        </>
    )
}

export function OneLabel3(props) {
    const { label, name, ...otherProps } = props
    useSnapshot(taskStore)
    let task = taskStore.current
    if (props.record) task = props.record
    return (
        <>
    <div style={{ display: "flex", flexDirection:'row',justifyContent:'space-between', gap: "20px", flexWrap: "wrap" }}>
    <div style={{ display: "flex",  gap: "8px" }}>
        <div style={{ fontWeight: "bold", minWidth: "100px" }}>{label}:</div>
        <div style={{ color: "#333", background: "#f5f5f5", padding: "4px 8px", borderRadius: "4px" }}>
            {task[name]}
        </div>
    </div>
</div>

</>

    )
}
export function OneLabel1(props) {
    const { label, name, ...otherProps } = props
    useSnapshot(taskStore)
    let task = taskStore.current
    if (props.record) task = props.record
    taskStore.current.totalAmount = Number(taskStore.current.netAmount) + Number(taskStore.current.gstAmount)
    return (
        <>
            <td>
                <div style={{ marginRight: '5px', marginTop: '3px' }}>{label}</div>
            </td>
            <td {...otherProps}>
                {
                    (name === 'dueDate') ?
                        <div>{Utils.formatToDateTime1(task.dueDate, task.dueTime)}</div>
                        : <div>{task[name]}</div>
                }
            </td>
        </>
    )
}
export function OneCell(props) {
    const { record, name, ...otherProps } = props
    useSnapshot(taskStore)
    const igmDetails = taskStore.current.igmDetails
    console.log("props",taskStore.current.igmDetails);
    const [exsitNo, setExist] = useState(false)
    const loseFocus =async(e)=>{
        if (e.target.value?.length >= 7 && igmDetails[0].name === "GIGM Number") {   
               //call 
               console.log(e.target.value);
               await Api.getSbAndBeNo({id:e.target.value,type:"igm"},(data)=>{
                console.log("return",data?.data[0]);
                if (data?.data[0]) {
                    taskStore.current.exsit = true
                setExist(data?.data[0]?.bookingNum)
                e.target.value = ""
                record[name] = ""
                }else{
                    taskStore.current.exsit = false
                    setExist(false)
                }
               })
               
        }
      }
    return (
        <>
            {
                (name === 'numPackages' || name === 'netWeight' || name === 'grossWeight' || name === 'volume') ? <>
                    <input {...otherProps} type={"number"} className={`input is-small ${(!taskStore.current.isValid && taskStore.current.isValidfield.indexOf(name) != -1) ? "is-danger" : ""} `} value={record[name]}
                        onChange={(e) => {
                            record[name] = e.target.value
                        }} />
                </> : <>
                    <input {...otherProps}  className={`input is-small ${(!taskStore.current.isValid && taskStore.current.isValidfield.indexOf(name) != -1) ? "is-danger" : ""} `} value={record[name]}
                        onChange={(e) => {
                            record[name] = e.target.value
                            loseFocus(e)
                        }} />
                </>
            }
            {exsitNo && <p style={{color:"#f03a5f"}}>This IGM No already exists for #{exsitNo}.</p>}
        </>

    )
}

export function OneInput1(props) {
    const { label, name, record, ...otherProps } = props
    const [cursor, setCursor] = useState(0)
    const ref = useRef(null)
    useSnapshot(myactionsstore)
    useEffect(() => {
        const input = ref.current
        if (input) {
            console.log("cursor---------", cursor)
            input.setSelectionRange(cursor, cursor)
        }
    }, [ref, cursor])
    if (record && record[name] == undefined) {
        record[name] = ""
    }

    const handleChange = (e) => {
        const formattedValue = e.target.value.replace(/[^a-zA-Z0-9]/g, ''); // Remove non-alphanumeric characters
        const letters = formattedValue.slice(0, 4); // Get the first 4 characters
        const numbers = formattedValue.slice(4, 11).replace(/[^0-9]/g, ''); // Get the next 7 numbers
        const combined = letters + numbers;
        setCursor(e.target.selectionStart)
        record[name] = combined
    }
    return (
        <>
            <div className="columns">
                <div className="column is-6 py-2">
                    <div style={{ marginRight: '2px', marginTop: '3px', fontWeight: "bold" }}>{label}</div>
                </div>
                <div className="column is-6 py-2">
                    {(record) ? <input {...otherProps}  style={{ width: "100%",marginLeft:"30px" }} ref={ref}
                        value={record[name]} className={myactionsstore.error.indexOf(name) == -1 ? "input is-small" : "input is-small is-danger"}
                        onChange={(e) => {
                            handleChange(e)
                            console.log('changed value =', record[name], record)
                        }}
                    /> : <></>
                    }
                </div>
            </div>
        </>
    )
}
export function OneInputPhone(props) {
    const { label, name, record, ...otherProps } = props
    const [cursor, setCursor] = useState(0)
    const ref = useRef(null)
    useSnapshot(myactionsstore)
    useEffect(() => {
        const input = ref.current
        if (input) {
            input.setSelectionRange(cursor, cursor)
        }
    }, [ref, cursor])
    if (record && record[name] == undefined) {
        record[name] = ""
    }

    const handleChange = (e) => {
        setCursor(e.target.selectionStart)
        record[name] = e.target.value
    }
    return (
        <>
            <div className="columns">
                <div className="column is-6 py-2">
                    <div style={{ marginRight: '5px', marginTop: '3px', fontWeight: "bold" }}>{label}</div>
                </div>
                <div className="column is-6 py-2">
                    {(record) ? <input {...otherProps} style={{ width: "100%" }} ref={ref}
                        value={record[name]} className={myactionsstore.error.indexOf(name) == -1? "input is-small" : "input is-small is-danger"}
                        onChange={(e) => {
                            handleChange(e)
                            console.log('changed value =', record[name], record)
                        }}
                        min="10"
                        onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                        }}

                    /> : <></>
                    }
                </div>
            </div>
        </>
    )
}

export function OneDate1(props) {
    const { label, name, record, ...otherProps } = props
    const [change, setChange] = useState(false)
    if (record && record[name] == undefined) {
        record[name] = ""
    }
    let value = ""
    if (record && record[name].length == 10) {
        // if(new Date(record[name]) == 'Invalid Date'){
        let l = record[name].split('-')
        value = record[name]
        console.log(record[name], l[0].length)
        if (l.length == 3 && l[0].length <= 2) {
            record[name] = `${l[2]}-${l[1]}-${l[0]}`
        }
        // }else{
        //     value = Utils.yyyymmdd(new Date(record[name]))
        //     console.log("2###########"+value)
        // }
    }
   


    return (
        <>
            <div className="columns">
                <div className="column is-6 py-2">
                    <div style={{ marginRight: '5px', marginTop: '3px', fontWeight: "bold" }}>{label}</div>
                </div>
                <div className="column is-6 py-2">
                    {(record) ? <input {...otherProps} type={"date"} style={{ width: "100%" }}
                        value={record[name] }
                        className={myactionsstore.error.indexOf(name) == -1 ? "input is-small" : "input is-small is-danger"}
                       
                        onChange={(e) => {
                            record[name] = e.target.value
                            if (change) {
                                setChange(false)
                            } else {
                                setChange(true)
                            }
                            console.log('changed value =', record[name])
                        }}
                    /> : <></>
                    }
                </div>
            </div>

        </>

    )
}
export function OneDateCurrent(props) {
    const { label, name, record, ...otherProps } = props
    const [change, setChange] = useState(false)
    if (record && record[name] == undefined) {
        record[name] = ""
    }
    let value = ""
    if (record && record[name].length == 10) {
        // if(new Date(record[name]) == 'Invalid Date'){
        let l = record[name].split('-')
        value = record[name]
        console.log(record[name], l[0].length)
        if (l.length == 3 && l[0].length <= 2) {
            record[name] = `${l[2]}-${l[1]}-${l[0]}`
        }
        // }else{
        //     value = Utils.yyyymmdd(new Date(record[name]))
        //     console.log("2###########"+value)
        // }
    }
    let min = ''
    let max =""
    min = Utils.getCurrentDateString()

    return (
        <>
            <div className="columns">
                <div className="column is-6 py-2">
                    <div style={{ marginRight: '5px', marginTop: '3px', fontWeight: "bold" }}>{label}</div>
                </div>
                <div className="column is-6 py-2">
                    {(record) ? <input {...otherProps} type={"date"} style={{ width: "100%" }}
                        value={record[name] }
                        className={myactionsstore.error.indexOf(name) == -1 ? "input is-small" : "input is-small is-danger"}
                        min={min}
                        max={max}
                        onKeyDown={(e) => {
                          e.preventDefault(); // Prevent any typing in date fields
                           
                        }}
                        onChange={(e) => {
                            record[name] = e.target.value
                            if (change) {
                                setChange(false)
                            } else {
                                setChange(true)
                            }
                            console.log('changed value =', record[name])
                        }}
                    /> : <></>
                    }
                </div>
            </div>

        </>

    )
}


export function AddressInput(props) {
    const { label = "Address", name = "address", record, ...otherProps } = props;
    const [cursor, setCursor] = useState(0);
    const ref = useRef(null);
    useSnapshot(myactionsstore);

    useEffect(() => {
        const input = ref.current;
        if (input) {
            input.setSelectionRange(cursor, cursor);
        }
    }, [ref, cursor]);

    if (record && record[name] === undefined) {
        record[name] = "";
    }

    const handleChange = (e) => {
        setCursor(e.target.selectionStart);
        record[name] = e.target.value;
    };

    return (
        <div className="columns">
            <div className="column is-6 py-2">
                <div style={{ marginRight: '5px', marginTop: '3px', fontWeight: "bold" }}>{label}</div>
            </div>
            <div className="column is-6 py-2">
                {record ? (
                    <textarea
                        {...otherProps}
                        style={{ width: "100%" }}
                        ref={ref}
                        value={record[name]}
                        className={myactionsstore.error.indexOf(name) === -1 ? "textarea is-small" : "textarea is-small is-danger"}
                        onChange={(e) => {
                            handleChange(e);
                            console.log('changed value =', record[name], record);
                        }}
                        placeholder="Enter your address"
                        rows={4} // Adjust the number of rows as needed
                    />
                ) : null}
            </div>
        </div>
    );
}



